import {Image as RNImage} from "react-native"
export default RNImage;
